module.exports = __webpack_public_path__ + "img/TH_logo_square_Anuja_Mehra.834ff575.jpg";